import { N0, N100 } from '@atlaskit/theme/colors';
export var tickBoxClassName = 'media-card-tickbox';
export var tickboxFixedStyles = "\n  background-color: ".concat("var(--ds-background-input, ".concat(N0, ")"), ";\n  color: ", "var(--ds-icon-subtle, ".concat(N100, ")"), ";\n");